import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class ProvinceService {
  index() {
    return axios.get(API_URL + "provinces?source=parcelin", {}).then(response => {
        return response.data;
    });
  }
}

export default new ProvinceService();